import classnames from 'classnames'

import { useQuinceRouter as useRouter } from '@src/modules/navigation'
import { Image } from '@src/quince-components/src/atoms'
import Swiper from '@src/quince-components/src/atoms/swiper'
import { NAV_POSITION } from '@src/quince-components/src/atoms/swiper/Swiper'
import { getProductLink } from '@src/quince-components/src/molecules/productCard/productCard.helpers'
import Product from '@src/quince-site-common/src/domains/Product'
import ProductImage from '@src/quince-site-common/src/domains/ProductImage'
import { ProductVariantOption } from '@src/quince-site-common/src/domains/ProductVariant'
import useDeviceInfo, { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'
import { isProductImage } from '@src/quince-site-common/src/utils/typeGuards'
import { TPDPSectionData } from '@src/quince-site-pdp/src/types/pdp-section-data.type'

import { useProductImages } from '../productImages/hooks/use-product-images'

import styles from './miniPDPProductImages.module.scss'

export const MiniPDPProductImages = ({
  product,
  sectionData,
  selectedOptions,
}: {
  product: Product
  sectionData: TPDPSectionData
  selectedOptions: ProductVariantOption[]
}) => {
  const { productMedia } = useProductImages(product, sectionData)
  const productImages = productMedia.filter(media => isProductImage(media))
  const router = useRouter()

  const deviceInfo = useDeviceInfo()
  const isMobile = deviceInfo.deviceType === DEVICE_TYPES.MOBILE

  const productLink = getProductLink(product, selectedOptions)
  const handleImageClick = () => {
    router.push(productLink)
  }

  return (
    <div className={styles.image_container}>
      <Swiper
        showDots={false}
        showNavigator={isMobile ? false : true}
        numberOfVisibleSlides={2}
        navPosition={NAV_POSITION.LEFT_RIGHT}
        variableWidth
        isChevronIcon={true}
        isIconWithBG={true}
        id={`mini-pdp-product-images`}
        slideClassName={styles.slideClassName}
        prevIconClass={classnames(styles.iconSize, styles.iconSize__prevIcon)}
        nextIconClass={classnames(styles.iconSize, styles.iconSize__nextIcon)}
      >
        {productImages.map((productImage, index) => (
          <div
            key={productImage.image.id}
            className={classnames(styles.image)}
            onClick={handleImageClick}
            role="button"
            aria-label={`View ${product.title} details`}
          >
            <Image
              {...ProductImage.makeImageProps(productImage)}
              loading={isMobile ? 'eager' : 'lazy'}
              fetchPriority={index === 0 || index === 1 ? 'high' : 'auto'}
              alt={productImage.image.title}
            />
          </div>
        ))}
      </Swiper>
    </div>
  )
}
